import { render, staticRenderFns } from "./tuiyijunren_tyjrjyqkcjb.vue?vue&type=template&id=f0cdd0f8&scoped=true"
import script from "./tuiyijunren_tyjrjyqkcjb.vue?vue&type=script&lang=js"
export * from "./tuiyijunren_tyjrjyqkcjb.vue?vue&type=script&lang=js"
import style0 from "./tuiyijunren_tyjrjyqkcjb.vue?vue&type=style&index=0&id=f0cdd0f8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0cdd0f8",
  null
  
)

export default component.exports